import styled from 'styled-components';
import { Close } from '@material-ui/icons';
import React from 'react';

const Btn = styled.button`
  border: 0;
  margin: 0;
  padding: 0.5rem;
  background: transparent;
  position: absolute;
  top: 20px;
  right: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CustomCloseIcon = styled(Close)`
  &&& {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

const CloseButton = ({ onClick }) => (
  <Btn onClick={onClick}>
    <CustomCloseIcon />
  </Btn>
);

export default CloseButton;
